/**
 * Machine-readable error codes for the clinic calendar API (ADR-0016). The
 * shared problem details filter keeps only `detail`, so the server puts the
 * code string in the exception message and clients match on it.
 */ /** HTTP 409: the `version` sent on `PUT /v1/branches/:id/hours` is stale. */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BRANCH_HOLIDAY_EXISTS () {
        return BRANCH_HOLIDAY_EXISTS;
    },
    get BRANCH_HOLIDAY_IN_PAST () {
        return BRANCH_HOLIDAY_IN_PAST;
    },
    get BRANCH_HOURS_VERSION_CONFLICT () {
        return BRANCH_HOURS_VERSION_CONFLICT;
    },
    get DOCTOR_AVAILABILITY_BRANCH_INVALID () {
        return DOCTOR_AVAILABILITY_BRANCH_INVALID;
    },
    get DOCTOR_AVAILABILITY_NOT_A_DOCTOR () {
        return DOCTOR_AVAILABILITY_NOT_A_DOCTOR;
    },
    get DOCTOR_AVAILABILITY_NOT_OWN () {
        return DOCTOR_AVAILABILITY_NOT_OWN;
    },
    get DOCTOR_AVAILABILITY_VERSION_CONFLICT () {
        return DOCTOR_AVAILABILITY_VERSION_CONFLICT;
    }
});
const BRANCH_HOURS_VERSION_CONFLICT = 'BRANCH_HOURS_VERSION_CONFLICT';
const BRANCH_HOLIDAY_IN_PAST = 'BRANCH_HOLIDAY_IN_PAST';
const BRANCH_HOLIDAY_EXISTS = 'BRANCH_HOLIDAY_EXISTS';
const DOCTOR_AVAILABILITY_NOT_OWN = 'DOCTOR_AVAILABILITY_NOT_OWN';
const DOCTOR_AVAILABILITY_NOT_A_DOCTOR = 'DOCTOR_AVAILABILITY_NOT_A_DOCTOR';
const DOCTOR_AVAILABILITY_VERSION_CONFLICT = 'DOCTOR_AVAILABILITY_VERSION_CONFLICT';
const DOCTOR_AVAILABILITY_BRANCH_INVALID = 'DOCTOR_AVAILABILITY_BRANCH_INVALID';
